<div class="visitor-registration-masterdata">
  <sc-padding>
    <sc-flex vertical fitHeight stretchContent>
      <sc-content-spacer vertical grow></sc-content-spacer>
      <ng-container [formGroup]="masterdataForm">

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.name"></sc-dictionary-label>
          </mat-label>
          <input matInput name="name" formControlName="name" [required]="true" minlength="row.minLength"
            maxlength="255">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.firstname"></sc-dictionary-label>
          </mat-label>
          <input matInput name="firstname" formControlName="firstname" [required]="true" minlength="row.minLength"
            maxlength="255">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.company"></sc-dictionary-label>
          </mat-label>
          <input matInput name="company" formControlName="company" [required]="true" minlength="row.minLength"
            maxlength="255">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.reason"></sc-dictionary-label>
          </mat-label>
          <input matInput name="reasonForVisit" formControlName="reasonForVisit" [required]="true"
            minlength="row.minLength" maxlength="255">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.visited-person"></sc-dictionary-label>
          </mat-label>
          <input matInput name="visitedPerson" formControlName="visitedPerson" [required]="true"
            minlength="row.minLength" maxlength="255">
        </mat-form-field>

        <app-numberplate-input [formGroup]="masterdataForm" formControlName="numberplate" minLengthInput="row.minLength"
          labelCheckbox="tmc-yard.entity.visit.no-vehicle"
          labelInput="tmc-yard.entity.visit.numberplate"></app-numberplate-input>

        <div class="checkbox">
          <mat-checkbox formControlName="entranceBarrierSecuredAreaNeeded">
            <sc-dictionary-label
              dictionaryKey="tmc-yard.entity.visit.entranceBarrierSecuredAreaNeeded"></sc-dictionary-label>
          </mat-checkbox>
        </div>

      </ng-container>
      <sc-content-spacer vertical grow></sc-content-spacer>
    </sc-flex>
  </sc-padding>
</div>
